import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentItemComponent } from 'app/partials/content-item/content-item.component';
import { MetafrenzyGuard } from 'ngx-metafrenzy';
import { BlogListComponent } from './blog-list/blog-list.component';

import { BlogComponent } from './blog.component';
import { BlogService } from './blog.service';

const routes: Routes = [
  {
    path: '',
    component: BlogComponent,
    canActivate: [MetafrenzyGuard],
    children: [
      {
        path: '',
        component: BlogListComponent,
        data: {
          metafrenzy: {
            title: $localize`:@@metadataBlogTitle:Wipperoz' blog where you will find all sorts of resourceful articles`,
            tags: [
              {
                name: 'description',
                content: $localize`:@@metadataBlogDescription:Digital content just for you; helpful tips, best life hacks and creative ideas to inspire you`
              },
              {
                name: 'og:title',
                content: $localize`:@@metadataBlogOgTitle:Your blog, our blog, the Wipperoz' blog`
              },
              {
                name: 'og:description',
                content: $localize`:@@metadataBlogOgDescription:Digital content just for you; helpful tips, best life hacks and creative ideas to inspire you`
              },
              {
                name: 'og:url',
                content: $localize`:@@metaDataBlogOgUrl:https://www.wipperoz.com/en/blog`
              },
              {
                name: 'twitter:url',
                content: $localize`:@@metaDataBlogTwitterUrl:https://www.wipperoz.com/en/blog`
              },
              {
                name: 'twitter:title',
                content: $localize`:@@metadataBlogTwitterTitle:Your blog, our blog, the Wipperoz' blog`
              },
              {
                name: 'twitter:card',
                content: 'summary'
              },
              {
                name: 'twitter:site',
                content: '@wipperoz'
              },
              {
                name: 'twitter:description',
                content: $localize`:@@metadataBlogTwitterDescription:Digital content just for you; helpful tips, best life hacks and creative ideas to inspire you`
              }
            ]
          }
        }
      },
      {
        path: ':id',
        component: ContentItemComponent,
        canActivate: [MetafrenzyGuard],
        resolve: { data: BlogService },
        data: {
          metafrenzy: {}
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlogRoutingModule {}
